// companyBoardStream.js — pure frame-decision for the board's CompanyBoardChannel subscription (m-r4-06).
//
// The board subscribes to its COMPANY's board lane (CompanyBoardChannel, server-gated by
// stream_for company). When a Task transition lands anywhere in the company — in ANY Session, not
// just the one the old single-session board hack watched — the server broadcasts a
// TASK_STATE_CHANGE frame and the board refetches its view-model.
//
// This module is PURE (no React/ActionCable deps) so the AC8 decision logic is node --test-able.

export const TASK_STATE_CHANGE = "TASK_STATE_CHANGE"

// Decide whether a CompanyBoardChannel frame should trigger a board refetch.
//
// Defense-in-depth company_id equality (AC8): the server stream is ALREADY tenant-gated
// (stream_for company + the fail-closed subscribe predicate), but we ALSO ignore any frame whose
// company_id !== the mounted company, so a stray/misrouted frame can never refetch the wrong
// tenant's board. When the mounted company is not yet known (board still loading), do not refetch.
export function shouldRefetchOnBoardFrame(frame, mountedCompanyId) {
  if (!frame || frame.type !== TASK_STATE_CHANGE) return false
  if (mountedCompanyId === null || mountedCompanyId === undefined) return false
  return frame.company_id === mountedCompanyId
}
